import { Component, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SubMenuStatus } from 'app/shared/models/global/sub-menu-status';
import { ComputationReturnService } from 'app/shared/services/computation-return/computation-return.service';
import { CommonService } from 'app/shared/services/global/common.service';
import { MessageService } from 'app/shared/services/global/message.service';

@Component({
	selector: 'app-sidenav',
	templateUrl: './sidenav.template.html',
})
export class SidenavComponent {
	@Input('items') public menuItems: any[] = [];
	@Input('hasIconMenu') public hasIconTypeMenuItem: boolean;
	@Input('iconMenuTitle') public iconTypeMenuTitle: string;

	subMenuList: SubMenuStatus[] = [];
	subMenuListDisplayNone: SubMenuStatus[] = [];
	hideShow = false;

	constructor(
		public common: CommonService,
		public router: Router,
		public message: MessageService,
		public activatedRoute: ActivatedRoute,
		public computationReturnService: ComputationReturnService
	) {
		window.addEventListener('scroll', this.scroll, true);
		setTimeout((event) => {
			this.scroll({ target: { scrollTop: 0 } });
		}, 10);

		this.common.subMenuValue.subscribe((value) => {
			let index = -1;
			if (value.isDisplayNone) {
				do {
					index = this.subMenuListDisplayNone.indexOf(this.subMenuListDisplayNone.find(row => row.sumMenuName === value.sumMenuName));
					if (index !== -1) {
						this.subMenuListDisplayNone.splice(index, 1);
					}
				} while (index !== -1);
				this.subMenuListDisplayNone.push(value);
				
				do {
					index = this.subMenuList.indexOf(this.subMenuList.find(row => row.sumMenuName === value.sumMenuName));
					if (index !== -1) {
						this.subMenuList.splice(index, 1);
					}
				} while (index !== -1);
			} else {
				do {
					index = this.subMenuList.indexOf(this.subMenuList.find(row => row.sumMenuName === value.sumMenuName));
					if (index !== -1) {
						this.subMenuList.splice(index, 1);
					}
				} while (index !== -1);
				this.subMenuList.push(value);

				do {
					index = this.subMenuListDisplayNone.indexOf(this.subMenuListDisplayNone.find(row => row.sumMenuName === value.sumMenuName));
					if (index !== -1) {
						this.subMenuListDisplayNone.splice(index, 1);
					}
				} while (index !== -1);
			}
		});
	}

	checkToHide(itemName) {
		for (const item of this.subMenuList) {
			if (item.sumMenuName === itemName && !item.isVisible) {
				return true;
			}
		}
		return false;
	}

	checkToDisplayNone(itemName) {
		for (const item of this.subMenuListDisplayNone) {
			if (item.sumMenuName === itemName && item.isDisplayNone) {
				return true;
			}
		}
		return false;
	}

	checkIsNavDisabled() {
		return this.common.checkIsNavDisabled();
	}

	setScrollToZero() {
		setTimeout((event) => {
			this.scroll({ target: { scrollTop: 0 } });
		}, 10);

	}

	scroll(event) {
		const scrollTop = event.target.scrollTop;
		if (scrollTop >= 200) {
			$('.fixed-btn-bottom').show();
		} else {
			$('.fixed-btn-bottom').hide();
		}
	}

	navigatePage(link, id) {
		console.log(link, id);
		this.router.navigate([link], {
			queryParams: {
				p_id: this.common.personID,
				f_id: this.common.selectedYearId,
				itr_id: this.common.selectedItrId
			},
			queryParamsHandling: 'merge',
		});
	}

	controlCompution(itemName) {
		const party = JSON.parse(atob(localStorage.getItem('party_type')));
		console.log("working");
		if (this.common.selectedYearId === 3 && (this.common.selectedItrId === 1 || this.common.selectedItrId === 4 || this.common.selectedItrId === 2 || this.common.selectedItrId === 3) && (party.party_type === 1 || party.party_type === 2)) {
			this.common.getFilingInfoStatus(this.common.personID, this.common.selectedYearId).then(filingStatus => {
				if (itemName !== 'Part A - General' && (filingStatus == null || filingStatus['regime'] == null)) {
					this.hideShow = true;
					this.message.displayPopup('Please select Tax Regime from PartA general>>Filing status>>Select Tax Regime');
					this.router.navigate(['/dashboard/part-general/filing-information'], {
						queryParams: {
							p_id: this.common.personID,
							f_id: this.common.selectedYearId,
							itr_id: this.common.selectedItrId
						},
						queryParamsHandling: 'merge',
					});
				} else {
					this.hideShow = false;
				}
			  });
		}
		if (this.common.selectedItrId === 6) {
			if (itemName === 'Computation and E-filing' && !this.common.isTypeOfCompany) {
				this.hideShow = true;
				// this.message.displayWarningToaster('Please fill "Type of Company" in "Part A-General-1"');
				this.message.displayWarningToaster('Please fill Personal Information details first!!');
				this.router.navigate(['/dashboard/part-general/personal-information'], {
					queryParams: {
						p_id: this.common.personID,
						f_id: this.common.selectedYearId,
						itr_id: this.common.selectedItrId
					},
					queryParamsHandling: 'merge',
				});
			} else {
				this.hideShow = false;
			}
		}
	}
}
